import React, { useState } from "react";

const initialState = { name: "", email: "", phone: "", message: "" };

export const Contact = (props) => {
  const data = props.data || {};
  const [form, setForm] = useState(initialState);
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const body = [
      `Name: ${form.name}`,
      `Email: ${form.email}`,
      `Phone: ${form.phone}`,
      "",
      form.message,
    ].join("\n");

    const subject = `Marble enquiry from ${form.name || "website visitor"}`;

    window.location.href = `mailto:${data.email}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    setSent(true);
  };

  return (
    <div id="contact">
      <div className="container">
        <div className="row">
          <div className="col-md-7">
            <div className="section-title">
              <h2>Send Us a Message</h2>
              <p>{data.intro}</p>
            </div>
            <form name="contactForm" onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Your name *"
                      required
                      value={form.name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="Email *"
                      required
                      value={form.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  className="form-control"
                  placeholder="Phone / WhatsApp"
                  value={form.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  id="message"
                  className="form-control"
                  rows="6"
                  placeholder="Tell us what you need — material, thickness, finish, quantity and destination port *"
                  required
                  value={form.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              {sent ? (
                <div className="form-status info">
                  Your email app should have opened with the message ready to send. If it
                  did not, write to us directly at {data.email}.
                </div>
              ) : null}
              <button type="submit" className="btn btn-custom btn-lg">
                Send Message
              </button>
              <p className="form-note">
                The form opens your own email app with the message filled in — nothing is
                stored on this site.
              </p>
            </form>
          </div>

          <div className="col-md-4 col-md-offset-1 contact-info">
            <h3>Contact Details</h3>
            <div className="contact-item">
              <p>
                <span><i className="fa fa-map-marker"></i> Address</span>
                {data.address}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span><i className="fa fa-phone"></i> Phone</span>
                <a href={`tel:${(data.phone || "").replace(/\s/g, "")}`}>{data.phone}</a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span><i className="fa fa-whatsapp"></i> WhatsApp</span>
                <a
                  href={`https://wa.me/${(data.whatsapp || "").replace(/[^0-9]/g, "")}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {data.whatsapp}
                </a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span><i className="fa fa-envelope-o"></i> Email</span>
                <a href={`mailto:${data.email}`}>{data.email}</a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span><i className="fa fa-clock-o"></i> Office hours</span>
                {data.hours}
              </p>
            </div>
            <div className="social">
              <ul>
                <li><a href={data.linkedin || "#"} aria-label="LinkedIn"><i className="fa fa-linkedin"></i></a></li>
                <li><a href={data.facebook || "#"} aria-label="Facebook"><i className="fa fa-facebook"></i></a></li>
                <li><a href={data.instagram || "#"} aria-label="Instagram"><i className="fa fa-instagram"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
